module.exports = __webpack_public_path__ + "img/9788958073703.4d8711e9.jpg";